import React from 'react'
import PropTypes from 'prop-types'
import './NavBar.scss'
import { Button } from 'components/UIElements'
import { goBack, navigateTo } from 'navigation'
import D3Logo from '../../assets/DCH-Logo.svg'

const AltNavBar = props => {
  const { closeText, close, back, backText, component } = props.navProps
  if (component) return component
  const onBackClick = back
    ? () => navigateTo(back)
    : goBack
  const onCloseClick = close
    ? () => navigateTo(close)
    : goBack
  return (
    <div className='navbar'>
      <div className='main alt'>
        <div>
          <img className='d3-logo' src={D3Logo} />
          {back && (
            <div className='back-link' onClick={onBackClick}>
              <i className='fa fa-arrow-left' />
              {backText}
            </div>
          )}
        </div>
        <Button grey content={closeText} onClick={onCloseClick} />
      </div>
    </div>
  )
}

AltNavBar.propTypes = {
  navProps: PropTypes.object,
  modalProps: PropTypes.object
}

export default AltNavBar
